import React, { Component } from 'react';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import queryString from 'query-string';
import ProsaPaymentSuccess from './ProsaPaymentSuccess.js';
import ProsaPaymentFailure from './ProsaPaymentFailure.js';
import { Link } from 'react-router-dom';
import prosaCodeResolver from './prosa/prosaCodeResolver.js'
import spinner from '../../../images/loading-spinner.gif';

let cancelToken;

class ProsaPaymentStatusContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      paymentStatusDone:false,
      paymentSuccesful:false,
      paymentSuccesfulPending:false,
      folio_externo:""
    }
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  componentWillMount() {

    var folio_externo = this.props.match? this.props.match.params.external_token:null;
    this.setState({folio_externo:folio_externo});

    cancelToken = axios.CancelToken.source();

    var eid = localStorage.getItem('EID');
    console.log('get EID',eid);

    var statusresult = this.statusResults;
    const values = queryString.parse(this.props.location.search);
    console.log("entity id ",eid);
    var bodyParameters = {
      entityId:eid
    };
    
    axios.get(process.env.REACT_APP_PROSA_STATUS_BASE_URL+values.resourcePath, bodyParameters)
    .then((response) => {statusresult(response)})
    .catch(function (error) {
      console.log(error);
    });
    
    
  }

  componentDidMount() {
   
  }

  statusResults = (response) =>{
    
    //var code = 'C'+response.data.result.code.replace(/\./g,'');
    console.log(response.data.result.code);
    var resultSuccess = prosaCodeResolver(response.data.result.code);
    console.log("resolvio:",resultSuccess);
    //var message = response.data.result.description;
    //var detailedMessage = response.data.resultDetails.ExtendedDescription;
    //console.log("codigo recibido 2"+code);
    //console.log("codigo relacionado 3"+CODES[code]); 
    if(resultSuccess == 1 || resultSuccess == 2){
      this.setState({ paymentSuccesful: true });
      if(resultSuccess == 2){
        this.setState({ paymentSuccesfulPending: true });
      }else{
        this.setState({ paymentSuccesfulPending: false });
      }
    }
    this.setState({ paymentStatusDone: true });
    //llamar ws para log del pago:
    var params = {
                  checkout_id: localStorage.getItem('EID'),
                  prosa_code : response.data.result.code,
                  token_session: this.props.getTokenSession(),
                  token_id: this.props.getTokenId(),
                  invoice_id: localStorage.getItem('invId'),
                  payment_amount: response.data.amount,
                  folio_externo: this.state.folio_externo
                };
    
    localStorage.removeItem('EID');
    localStorage.removeItem('invId');

    this.props.post(
      "/payInvoice",
      params,
      (response) => this.afterNotification(response),
      (error) => {
        this.setState({ isSearching: false });
        this.props.handleErrorResponse(error);
      },
      cancelToken,
      () => this.setState({ isSearching: false })
    );
    
  }

  afterNotification = (response) => {
    console.log(response);
  }

  

  render() {
    const { t } = this.props;
    return( 
      <div>
        { !this.state.paymentStatusDone && <img
            width="45px"
            height="45px"
            alt={t('dashboard.reservations.img_spinner')}
            className={this.state.paymentStatusDone ? "" : "hidden"}
            src={spinner} />}

       { this.state.paymentStatusDone &&  this.renderPaymentStatus()}        

      </div>
    );
  }

  renderPaymentStatus = () => {
    const { t } = this.props;
    return(
      <div>   
        {this.state.paymentSuccesful ? <ProsaPaymentSuccess successButPending={this.state.paymentSuccesfulPending} /> :  <ProsaPaymentFailure/>}
        <div>
        {/*<Link className="" to="/invoices">
          <i className="fa fa-fw fa-arrow-left" />&nbsp;
          {t('dashboard.btn_back')}
        </Link>*/}
        <a href="javascript:history.go(-2)">
          <i className="fa fa-fw fa-arrow-left" />&nbsp;
          {t('dashboard.btn_back')}
        </a>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(ProsaPaymentStatusContainer);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/ProsaPaymentStatusContainer.js